import Router from "./route/Index";

import ThemeProvider from "./layout/provider/Theme";
import SystemLoaders from "./route/SystemLoaders";
import * as app_consts from "./utils/app_consts";
import { Provider } from "react-redux";
import { system_loaders_store } from "./app_store/system_loaders_store";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { no_auth_tenants_store } from "./app_store/no_auth_tenants_store";
import NoAuthTenants from "./route/NoAuthTenants";
import AuthTenants from "./route/AuthTenants";
import { auth_tenants_store } from "./app_store/auth_tenants_store";


let dashboard_status;
let dashboard_tenant;
let account_type;
let system_loading_status;
let login_access;

// Check Local Storage Status
if (localStorage.getItem("dashboard_tenant"))
{
  // Logs in Tenant Variables are present
  dashboard_status = true;
  system_loading_status = false;
  if (localStorage.getItem("user_account"))
  {
    login_access = true;
    account_type = JSON.parse(localStorage.getItem("user_account"))?.type;
  }
} else
{
  // Logs out user if Variables aren't present
  dashboard_status = false;
  account_type = null;
  system_loading_status = true;
  login_access = null;
}

const App = () => {

  // State that holds Login Status
  const [isSignIn, setIsSignIn] = useState(login_access);
  const [profile_type, setProfileType] = useState(account_type);

  // UseEffect to Get Account Type ID
  useEffect(() => {
    setProfileType(account_type);
  }, [account_type]);

  return (
    <>
      <ThemeProvider>
        {
          system_loading_status ?
            <>
              <Provider store={system_loaders_store}>
                <SystemLoaders type={app_consts.MAIN_SYSTEM_LOADER} />
                <ToastContainer />
              </Provider>
            </>
            :
            <>
              {/* Check if User Is Logged In */}
              {
                isSignIn ?
                  <>
                    <Provider store={auth_tenants_store}>
                      <AuthTenants />
                      <ToastContainer />
                    </Provider>
                  </>
                  :
                  <>
                    <Provider store={no_auth_tenants_store}>
                      <NoAuthTenants />
                    </Provider>
                    <ToastContainer />
                  </>
              }
            </>
        }
      </ThemeProvider>
    </>
  );
};
export default App;